"use client";

import { CheckIcon, CopyIcon } from "@phosphor-icons/react/ssr";
import { useCallback } from "react";
import { Button } from "@/components/ui/button";
import { useCopyToClipboard } from "@/hooks/use-copy-to-clipboard";
import { cn } from "@/lib/utils";

/** Copies the page as markdown, which the site serves at the page's address under /llm. */
export function DocsCopyPage({ url }: { url: string }) {
  const { copyToClipboard, isCopied } = useCopyToClipboard();
  const handleCopy = useCallback(
    () =>
      copyToClipboard(
        fetch(new URL(url).pathname.replace("/docs", "/llm")).then((response) =>
          response.text()
        )
      ),
    [copyToClipboard, url]
  );

  return (
    <Button
      className="site-rounded-md h-8 shadow-none md:h-7 md:text-[0.8rem]"
      onClick={handleCopy}
      size="sm"
      variant="secondary"
    >
      <span className="relative inline-flex">
        <CheckIcon
          aria-hidden="true"
          className={cn(
            "absolute inset-0 transition-[opacity,filter,scale] duration-250 ease-in-out will-change-[opacity,filter,scale] motion-reduce:transition-none",
            isCopied
              ? "scale-100 opacity-100 blur-0"
              : "scale-[0.25] opacity-0 blur-[2px]"
          )}
        />
        <CopyIcon
          aria-hidden="true"
          className={cn(
            "transition-[opacity,filter,scale] duration-250 ease-in-out will-change-[opacity,filter,scale] motion-reduce:transition-none",
            isCopied
              ? "scale-[0.25] opacity-0 blur-[2px]"
              : "scale-100 opacity-100 blur-0"
          )}
        />
      </span>
      Copy Markdown
    </Button>
  );
}
